// Copyright (c) 2022 by Move Closer

import { VueConstructor } from 'vue'

import { AlertTheme } from './Alert.contracts'
import Danger from './partials/DangerIcon.vue'
import Info from './partials/InfoIcon.vue'
import Success from './partials/SuccessIcon.vue'
import Warning from './partials/WarningIcon.vue'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const variantsIconRegistry: Record<string, VueConstructor> = {
  [AlertTheme.Danger]: Danger as VueConstructor,
  [AlertTheme.Info]: Info as VueConstructor,
  [AlertTheme.Success]: Success as VueConstructor,
  [AlertTheme.Warning]: Warning as VueConstructor
}
